module.exports = __webpack_public_path__ + "img/servigua.abad7057.jpg";